import { render, staticRenderFns } from "./Recommendations.vue?vue&type=template&id=a671ce2a&scoped=true&lang=pug"
import script from "./Recommendations.vue?vue&type=script&lang=js"
export * from "./Recommendations.vue?vue&type=script&lang=js"
import style0 from "./Recommendations.vue?vue&type=style&index=0&id=a671ce2a&prod&lang=scss&scoped=true"
import style1 from "./Recommendations.vue?vue&type=style&index=1&id=a671ce2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a671ce2a",
  null
  
)

export default component.exports